export default "__VITE_ASSET__CEbtMa$C__"